"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _templateObject, _templateObject2, _templateObject3;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var react_datepicker_1 = __importDefault(require("react-datepicker"));

var styled_1 = __importDefault(require("@emotion/styled"));

require("react-datepicker/dist/react-datepicker.css");

var Input_1 = __importDefault(require("./Input"));

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var DatePicker = function DatePicker(_ref) {
  var _ref$startDate = _ref.startDate,
      startDate = _ref$startDate === void 0 ? new Date() : _ref$startDate,
      _ref$endDate = _ref.endDate,
      endDate = _ref$endDate === void 0 ? new Date() : _ref$endDate,
      _ref$minDate = _ref.minDate,
      minDate = _ref$minDate === void 0 ? new Date("01/01/2000") : _ref$minDate,
      _ref$maxDate = _ref.maxDate,
      maxDate = _ref$maxDate === void 0 ? null : _ref$maxDate,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? "MM/dd/yyyy" : _ref$format,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      dataTestId = _ref.dataTestId,
      label = _ref.label,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      _onChange = _ref.onChange,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      language = _ref.language,
      sizeMobile = _ref.sizeMobile,
      disableWeekends = _ref.disableWeekends,
      inputRef = _ref.inputRef;
  var refCustomInput = (0, react_1.useRef)();

  var _ref2 = (0, react_1.useState)(startDate),
      _ref3 = _slicedToArray(_ref2, 2),
      date = _ref3[0],
      setDate = _ref3[1];

  var _ref4 = (0, react_1.useState)(""),
      _ref5 = _slicedToArray(_ref4, 2),
      nativeDateString = _ref5[0],
      setNativeDateString = _ref5[1];

  var _ref6 = (0, frontend_common_1.useDeviceDetect)(),
      isMobile = _ref6.isMobile;

  var _ref7 = (0, react_1.useState)(false),
      _ref8 = _slicedToArray(_ref7, 2),
      open = _ref8[0],
      setOpen = _ref8[1];

  var _ref9 = (0, frontend_theme_1.useTheme)(),
      theme = _ref9.theme;

  (0, react_1.useEffect)(function () {
    var parts = [];

    if (date) {
      parts = [date.getUTCFullYear().toString(), (0, frontend_common_1.padStart)((date.getUTCMonth() + 1).toString(), 2, "0"), (0, frontend_common_1.padStart)(date.getUTCDate().toString(), 2, "0")];
    }

    if (parts.every(Boolean)) {
      setNativeDateString(parts.join("-"));
    }
  }, [date]);
  (0, react_1.useEffect)(function () {
    setDate(startDate);
  }, [startDate]);
  var InputContainer = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\tposition: relative;\n\t\t// overriding react-datepicker's wrapper component that defaults to inline-block\n\t\t& > div {\n\t\t\tdisplay: block;\n\t\t}\n\t"])));
  var NativeInputWrapper = styled_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\tinput[type=\"date\"] {\n\t\t\toutline: none;\n\t\t}\n\t\tinput[type=\"date\"]::-webkit-inner-spin-button,\n\t\tinput[type=\"date\"]::-webkit-calendar-picker-indicator {\n\t\t\topacity: 0;\n\t\t\t-webkit-appearance: none;\n\t\t\toutline: none;\n\t\t}\n\t\tdiv.icon-container {\n\t\t\tpointer-events: none;\n\t\t}\n\t"])));
  var ReactDatePickerWrapper = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\tdiv.react-datepicker-wrapper {\n\t\t\tdisplay: block;\n\t\t\toutline: none;\n\t\t}\n\t\t", "\n\n\t\t.react-datepicker__triangle {\n\t\t}\n\n\t\t.react-datepicker__triangle {\n\t\t\tborder-bottom-color: ", " !important;\n\t\t}\n\t\t.react-datepicker__header {\n\t\t\tbackground-color: ", ";\n\t\t}\n\t\t.react-datepicker__current-month,\n\t\t.react-datepicker__day-name {\n\t\t\tcolor: ", ";\n\t\t}\n\t\t.react-datepicker__day--selected {\n\t\t\tcolor: #fff;\n\t\t\tbackground: ", ";\n\t\t}\n\t"])), disableWeekends && ".react-datepicker__day--weekend:not(.react-datepicker__day--disabled) \n\t\t\t { pointer-events: none;  opacity: 0.2; }", theme.colors[type].background, theme.colors[type].background, theme.colors[type].text, theme.colors.primary.selected); // Below function is used only return date for mobile view

  var dateToString = function dateToString(date) {
    var year = date.getFullYear();
    var month = (date.getMonth() + 1).toString().padStart(2, "0");
    var day = date.getDate().toString().padStart(2, "0");
    return "".concat(year, "-").concat(month, "-").concat(day);
  };

  var CustomInput = react_1.default.forwardRef(function (props, ref) {
    return (0, jsx_runtime_1.jsx)(Input_1.default, Object.assign({}, props, {
      type: type,
      size: size,
      label: label,
      inputRef: ref,
      icon: "calendar",
      onIconClick: function onIconClick() {
        if (!disabled) {
          setOpen(true);
        }
      },
      iconPosition: "right",
      dataTestId: dataTestId,
      isValid: required ? props.value.length > 0 : true,
      onFocus: function onFocus() {
        return setOpen(true);
      },
      sizeMobile: sizeMobile
    }));
  });

  var renderNativeDateInput = function renderNativeDateInput() {
    return (0, jsx_runtime_1.jsx)(NativeInputWrapper, {
      children: (0, jsx_runtime_1.jsx)(Input_1.default, {
        type: type,
        inputRef: inputRef,
        size: size,
        label: label,
        inputType: "date",
        required: required,
        disabled: disabled,
        "aria-disabled": disabled ? true : false,
        value: nativeDateString,
        icon: "calendar",
        iconPosition: "right",
        dataTestId: dataTestId,
        onChange: function onChange(e) {
          var date = new Date("".concat(e.target.value, "T00:00:00"));
          setDate(date);

          _onChange(date, e);
        },
        min: minDate ? dateToString(minDate) : "",
        max: maxDate ? dateToString(maxDate) : "",
        language: language,
        sizeMobile: sizeMobile
      })
    });
  };

  var renderReactDatePicker = function renderReactDatePicker() {
    return (0, jsx_runtime_1.jsx)(ReactDatePickerWrapper, {
      "data-testid": dataTestId,
      children: (0, jsx_runtime_1.jsx)(react_datepicker_1.default, {
        tabIndex: 0,
        peekNextMonth: true,
        shouldCloseOnSelect: true,
        minDate: minDate,
        maxDate: maxDate,
        endDate: endDate,
        selected: date,
        required: required,
        disabled: disabled,
        "aria-disabled": disabled ? true : false,
        dateFormat: format,
        dropdownMode: "select",
        onChange: function onChange(date, event) {
          setDate(date);
          date && _onChange(date, event);
        },
        customInput: (0, jsx_runtime_1.jsx)(CustomInput, {
          ref: refCustomInput
        }),
        open: open,
        onClickOutside: function onClickOutside() {
          return setOpen(false);
        },
        popperPlacement: "top"
      })
    });
  };

  return (0, jsx_runtime_1.jsx)(InputContainer, {
    children: isMobile ? renderNativeDateInput() : renderReactDatePicker()
  });
};

exports.default = DatePicker;